//PrivateRoute.js

import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import axiosInstance from '../services/api';

const PublicRoute = () => {
  const [status, setStatus] = useState('checking');
  
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          setStatus('unauthenticated');
          return;
        }
        
        // Verify token validity
        await axiosInstance.get('/profile/');
        setStatus('authenticated');
      } catch {
        localStorage.clear();
        setStatus('unauthenticated');
      }
    };

    checkAuth();
  }, []);

  if (status === 'checking') {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', pt: 4 }}>
        <CircularProgress size={40} />
      </Box>
    );
  }

  return status === 'unauthenticated' ? <Outlet /> : <Navigate to="/dashboard" replace />;
};

export default PublicRoute;